import { MyOptionType } from '@procsea/design-system'

import { RequestableProduct } from 'src/types'

import {
  RequestableProductOptionType,
  getRequestableProductOption,
} from './useRequestableProductOptions'

interface GetAllRequestableProductOptionsArgs {
  value?: MyOptionType<RequestableProduct> | null
  requestableProductOptions: RequestableProductOptionType[]
}

export const getAllRequestableProductOptions = ({
  value,
  requestableProductOptions,
}: GetAllRequestableProductOptionsArgs) => {
  if (!value) {
    return requestableProductOptions
  }

  const index = requestableProductOptions.findIndex(
    requestableProductOption => requestableProductOption.value.value.id === value.value.id
  )

  if (index === -1) {
    return [...requestableProductOptions, getRequestableProductOption(value.value)]
  }

  const newRequestableProductOptions = [...requestableProductOptions]

  newRequestableProductOptions[index] = getRequestableProductOption(value.value)

  return newRequestableProductOptions
}
